module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Rob Boffard\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('B', [_vm._v("Rob Boffard")]), _vm._v(" is a South African author who splits his time between London, Vancouver and Johannesburg. He has worked as a journalist for over a decade, and has written articles for publications in more than a dozen countries, including the "), _c('I', [_vm._v("Guardian")]), _vm._v(" and "), _c('I', [_vm._v("Wired")]), _vm._v(" in the UK.")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/UuqnH/images/9780316519120.jpg?1732976220331",
      "alt": "This image is the cover for the book Adrift"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Adrift\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("\"An edge-of-the-seat epic of survival and adventure in deep space.\" -- Gareth L. Powell, BSFA Award-Winning author")]), _c('br'), _c('br'), _vm._v("Sigma Station. The ultimate luxury hotel, in the far reaches of space."), _c('br'), _c('br'), _vm._v("For one small group, a tour of the Horsehead Nebula is meant to be a short but stunning highlight in the trip of a lifetime."), _c('br'), _c('br'), _vm._v("But when a mysterious ship destroys Sigma Station and everyone on it, suddenly their tourist shuttle is stranded."), _c('br'), _c('br'), _vm._v("They have no weapons. No food. No water. No one back home knows they're alive."), _c('br'), _c('br'), _vm._v("And the mysterious ship is hunting them.\n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Orbit\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0